import type { TFunction } from 'i18next';

/**
 * Etiqueta de un menú en el sidebar. Se busca primero en `sidebar.menus.*`, que
 * son los textos calcados de sporttia-competitions ("Mi Centro Deportivo",
 * "Reservas Fijas"…), y si no está se cae a la clave global de siempre: así un
 * menú nuevo en menus.json sigue apareciendo con su traducción habitual.
 */
export function menuLabel(t: TFunction, caption: string): string {
    return t(`sidebar.menus.${caption}`, { defaultValue: t(caption) });
}
